export const contentMappingTransfer = {
    package: {
        speedy_shuttle: {
            heading: 'Speedy Shuttle',
            description:
                'Transfer im Bus-Shuttle vom Flughafen zu Ihrem Hotel und zurück. Die Wartedauer am Flughafen beträgt maximal 45 Minuten und es werden höchstens sechs Hotels angefahren.',
            short_description: 'Bus Transfer ab Flughafen',
        },
        shuttle: {
            heading: 'Shuttle',
            description:
                'Transfer im Bus-Shuttle vom Flughafen zu Ihrem Hotel und zurück. Die Wartedauer am Flughafen kann bis zu 70 Minuten betragen, die Fahrtzeit ist von der Anzahl der angefahrenen Hotels abhängig (maximal 15 Stopps).',
            short_description: 'Shuttle Transfer ab Flughafen',
        },
        taxi: {
            heading: 'Privattransfer',
            description:
                'Privattransfer vom Flughafen zu Ihrem Hotel und zurück. Sie werden von Ihrem Fahrer abgeholt und gelangen bequem ohne Zwischenhalte an Ihr Ziel.',
            short_description: 'Privattransfer ab Flughafen',
        },
    },
    cruise: {
        taxi: {
            heading: 'Privattransfer',
            description:
                'Privattransfer vom Flughafen zum Hafen und zurück. Sie werden von Ihrem Fahrer abgeholt und gelangen ohne Zwischenhalte an Ihr Ziel. Bitte beachten Sie, dass der Ausstieg nicht immer unmittelbar am Schiff erfolgen kann. Der letzte Abschnitt zum Kreuzfahrtterminal muss unter Umständen zu Fuß mit dem Gepäck zurückgelegt werden.',
            short_description: 'Privattransfer ab Flughafen zum Hafen',
        },
        shuttle: {
            heading: 'Gemeinsames Shuttle',
            description:
                'Transfer im Bus-Shuttle vom Flughafen zum Hafen und zurück. Bitte beachten Sie, dass der Ausstieg nicht immer unmittelbar am Schiff erfolgen kann. Der letzte Abschnitt zum Kreuzfahrtterminal muss unter Umständen zu Fuß mit dem Gepäck zurückgelegt werden.',
            short_description: 'Shuttle Transfer ab Flughafen zum Hafen',
        },
    },
};
export default contentMappingTransfer;
